module.exports = __webpack_public_path__ + "static/img/q.d5d7920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/q.png
// module id = ERQv
// module chunks = 1